<template>
  <div>
    <div id="home-page" class="full-page">
      <!-- Full Screen Posts View -->
      <div v-show="!galleryView" class="posts">
        <div class="each-post" v-for="post, index in posts">
          <FullScreenPost :post="post" :index="index" :posts="posts" :displaySettings="displaySettings" />
        </div>
      </div>

      <!-- Gallery View -->
      <div v-show="galleryView" class="gallery-posts">
        <div class="gallery-container">
          <div
            v-for="(post, index) in posts"
            :key="`gallery-${post.id}`"
            class="gallery-item"
            :style="{
              backgroundImage: `url('${post.thumbnail}')`,
              animationDelay: `${index * 0.05}s`
            }"
            @click="openPost(post)"
          >
            <div class="gallery-overlay">
              <h3 class="gallery-title">{{ post.title }}</h3>
              <p class="gallery-date">{{ post.date }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Slider -->
    <transition name="drawer">
      <div v-show="showBottomSlider" class="bottom-slider">
        <div class="slider-container">
          <!-- Gallery Toggle Icon (First Item) -->
          <div
            class="gallery-toggle-btn"
            @click="toggleGalleryView"
            :class="{ active: galleryView }"
            :title="galleryView ? 'Switch to Full Screen View' : 'Switch to Gallery View'"
          >
            <div class="gallery-icon">
              <div class="icon-grid">
                <span></span><span></span><span></span>
                <span></span><span></span><span></span>
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>

          <!-- Post Thumbnails -->
          <div
            v-for="(post, index) in posts"
            :key="post.id"
            class="slider-thumbnail"
            :style="{ backgroundImage: `url('${post.thumbnail}')` }"
            @click="scrollToPost(post)"
            :title="post.title"
          >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template><script>
export default {
  name: "home",
  data: function () {
    return {
      loading: true,
      posts: [],
      featured: [],
      latest: null,
      categories: [],
      levels: [],
      filters: {
        title: "",
        category: null,
        level: null,
      },
      displaySettings: {
        showTitles: screen.width < 768,
      },
      search: '',
      firstEnter: false,
      showBottomSlider: false,
      galleryView: false,
      keyupHandler: null,
      mousemoveHandler: null,
      mouseleaveHandler: null,
    };
  },
  async mounted() {
    const response = await axios.get("/client/posts");

    window.scrollTo(0, 0);

    this.loading = false;
    this.$emit("load-finish");
    this.posts = response.data.posts;
    this.featured = response.data.featured;
    this.latest = response.data.latest;

    this.registerEventListeners();
    this.registerMouseListener();
  },
  computed: {
    categoriesWithPosts() {
      return this.categories.filter((cat) => cat.count !== 0);
    },
  },
  methods: {
    async filter() {
      const vm = this;

      axios
        .get("/client/posts", {
          params: {
            filters: this.filters,
          },
        })
        .then(function (response) {
          vm.posts = response.data.posts;
        });
    },
    openCarouselPost(post) {
      this.$router.push({ path: `post/${post.slug}` });
    },
    openPost(post) {
      this.$router.push({ path: `post/${post.slug}` });
    },
    toggleGalleryView() {
      this.galleryView = !this.galleryView;
    },
    scrollToPost(post) {
      if (this.galleryView) {
        // In gallery view, just scroll to the post item
        const element = document.querySelector(`.gallery-item[style*="${post.thumbnail}"]`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        // In full screen view, use the existing logic
        const element = document.querySelector(`.each-post[data-id="${post.id}"]`);
        if (element) {
          element.scrollIntoView({ behavior: "instant" });
          element.classList.remove('bannerAnimation');
          void element.offsetWidth; // trigger reflow
          element.classList.add('bannerAnimation');
        }
      }
    },
    registerEventListeners() {
      this.keyupHandler = (event) => {
        // Don't process if user is typing in an input or textarea
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
          return;
        }

        if (event.code === "Escape") {
          this.displaySettings.showTitles = !this.displaySettings.showTitles;
        }
        if (event.code.startsWith("Key")) {
          this.search += event.key;
          console.log(this.search);
        }
        if (event.code === "Backspace") {
          this.search = ''
          this.firstEnter = false;
        }
        // If enter and firstEnter = false, find the post that starts with the search, then scroll to it, case insensitive
        if (event.code === "Enter") {
          const normalizedSearch = this.search.toLowerCase().replace(/\s+/g, '');

            const post = [...this.posts].reverse().find((post) => {
            const normalizedTitle = post.title.toLowerCase().replace(/\s+/g, '');
            return normalizedTitle.includes(normalizedSearch);
          });

          if (post) {
            if (this.firstEnter) {
              // Route change to post using post.slug
              this.firstEnter = false;
              this.$router.push({ path: `post/${post.slug}` });
            } else {
              const element = document.querySelector(`.each-post[data-id="${post.id}"]`);
              console.log(element);
              if (element) {
                element.scrollIntoView({ behavior: "instant" })
                element.classList.remove('bannerAnimation');
                void element.offsetWidth; // <-- trigger reflow
                element.classList.add('bannerAnimation');
              }
            }
          }

          this.firstEnter = true;
        }
      };

      window.addEventListener("keyup", this.keyupHandler);
    },
    registerMouseListener() {
      this.mousemoveHandler = (event) => {
        const windowHeight = window.innerHeight;
        const mouseY = event.clientY;

        // Show slider when mouse is within 100px of the bottom of the viewport
        const distanceFromBottom = windowHeight - mouseY;
        const isNearBottom = distanceFromBottom <= 180;

        this.showBottomSlider = isNearBottom;
      };

      this.mouseleaveHandler = () => {
        this.showBottomSlider = false;
      };

      // Listen for mouse movement instead of scroll
      window.addEventListener('mousemove', this.mousemoveHandler);

      // Hide when mouse leaves the window
      window.addEventListener('mouseleave', this.mouseleaveHandler);
    },
  },
  beforeDestroy() {
    // Clean up event listeners when component is destroyed
    if (this.keyupHandler) {
      window.removeEventListener('keyup', this.keyupHandler);
    }
    if (this.mousemoveHandler) {
      window.removeEventListener('mousemove', this.mousemoveHandler);
    }
    if (this.mouseleaveHandler) {
      window.removeEventListener('mouseleave', this.mouseleaveHandler);
    }
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: black;
}

a:link,
a:active,
a:visited,
a:hover {
  text-decoration: none;
}

.home-section {
  font: 26px Arial, Helvetica, sans-serif;
  color: rgba(80, 80, 80, 1);
  font-weight: 700;
  margin: 0px 0 15px 0;
  padding-top: 10px;
  text-align: left;
}

.filters {
  background: #102030;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 1px 1px rgba(200, 200, 200, 1);
  margin-bottom: 15px;

  .row {
    padding: 0 15px;
  }

  .filter-separator {
    padding: 0 10px;
  }

  .post-search-input,
  select {
    border-bottom: 1px solid white;
    color: white;
    width: 100%;
  }

  .post-search-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
}



.post-search-select-option {
  color: black;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.posts {
  padding-bottom: 26vh; /* Add space for the fixed bottom slider - increased size */
}

/* Drawer animation */
.drawer-enter-active, .drawer-leave-active {
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.drawer-enter, .drawer-leave-to {
  transform: translateY(100%);
}

.bottom-slider {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 26vh; /* Increased from 5vh to 26vh */
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(15px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1000;
}

.slider-container {
  display: flex;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 10px;
  align-items: center;
  gap: 2px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
}

.slider-thumbnail {
  flex-shrink: 0;
  height: calc(26vh - 24px); /* Adjusted for the larger slider */
  width: calc((26vh - 24px) * 16 / 9); /* 16:9 aspect ratio */
  background-size: cover;
  background-position: center;
  border-radius: 6px; /* Slightly larger border radius */
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
    transform: scale(1.05); /* Reduced scale since thumbnails are larger now */
  }
}

/* Gallery Toggle Button */
.gallery-toggle-btn {
  flex-shrink: 0;
  height: calc(26vh - 24px);
  width: calc(14vh - 24px); /* Square for the icon */
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.6);
    transform: scale(1.05);
  }

  &.active {
    background: rgba(255, 255, 255, 0.9);
    border-color: white;

    .gallery-icon .icon-grid span {
      background: #000;
    }
  }
}

.gallery-icon {
  .icon-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
    width: 20px;
    height: 20px;

    span {
      background: rgba(255, 255, 255, 0.8);
      border-radius: 1px;
      transition: background 0.3s ease;
    }
  }
}

/* Gallery View Styles */
.gallery-posts {
  padding: 120px 80px; /* Increased top padding from 80px to 120px */
  background: #000;
}

.gallery-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns instead of 4 */
  gap: 25px; /* Slightly larger gap for bigger images */
  margin: 0 auto;
}

.gallery-item {
  width: 100%;
  margin: 0;
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  animation: galleryItemEnter 0.6s ease forwards;

  /* Uniform size - all 16:9 aspect ratio */
  aspect-ratio: 16/9;

  /* Y-axis displacement for visual variety */
  &:nth-child(3n+1) {
    transform: translateY(0px); /* First column - no offset */
  }

  &:nth-child(3n+2) {
    transform: translateY(15px); /* Second column - slight down offset */
  }

  &:nth-child(3n+3) {
    transform: translateY(30px); /* Third column - more down offset */
  }

  /* Override transform during animation */
  &.gallery-item {
    &:nth-child(3n+1) {
      animation: galleryItemEnter1 0.6s ease forwards;
    }

    &:nth-child(3n+2) {
      animation: galleryItemEnter2 0.6s ease forwards;
    }

    &:nth-child(3n+3) {
      animation: galleryItemEnter3 0.6s ease forwards;
    }
  }  &:hover {
    transform: scale(1.02);
    transition: transform 0.3s ease;

    .gallery-overlay {
      opacity: 1;
    }
  }
}

.gallery-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 30px 15px 15px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-title {
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 5px 0;
  line-height: 1.2;
}

.gallery-date {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  margin: 0;
}

@keyframes galleryItemEnter1 {
  to {
    opacity: 1;
    transform: translateY(0px); /* First column stays at normal position */
  }
}

@keyframes galleryItemEnter2 {
  to {
    opacity: 1;
    transform: translateY(15px); /* Second column offset down */
  }
}

@keyframes galleryItemEnter3 {
  to {
    opacity: 1;
    transform: translateY(30px); /* Third column offset down more */
  }
}

@keyframes galleryItemEnter {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive gallery */
@media screen and (max-width: 900px) {
  .gallery-container {
    grid-template-columns: repeat(2, 1fr); /* 2 columns for tablets */
    gap: 20px;
  }

  .gallery-posts {
    padding: 100px 15px 12vh 15px;
  }

  /* Update Y-axis displacement for 2 columns */
  .gallery-item {
    &:nth-child(2n+1) {
      animation: galleryItemEnter1 0.6s ease forwards;
    }

    &:nth-child(2n+2) {
      animation: galleryItemEnter2 0.6s ease forwards;
    }

    /* Reset 3-column specific rules */
    &:nth-child(3n+3) {
      animation: none;
    }
  }
}

@media screen and (max-width: 768px) {

  .home-section {
    font: 26px Arial, Helvetica, sans-serif;
    padding: 30px 0 15px 0;
    margin: 0 0 5px 0;
  }

  .gallery-container {
    grid-template-columns: repeat(1, 1fr); /* 1 column for mobile */
    gap: 15px;
  }

  .gallery-posts {
    padding: 80px 10px 15vh 10px; /* Increased top padding for mobile */
  }

  /* Single column - no Y displacement needed */
  .gallery-item {
    &:nth-child(n) {
      animation: galleryItemEnter1 0.6s ease forwards !important;
    }
  }

  .gallery-toggle-btn {
    height: calc(15vh - 24px);
    width: calc(15vh - 24px);
  }

  .posts {
    padding-bottom: 15vh; /* Increased padding for mobile */
  }

  .bottom-slider {
    height: 15vh; /* Larger on mobile for better touch interaction */
  }

  .slider-thumbnail {
    height: calc(15vh - 24px); /* Adjusted for mobile */
    width: calc((15vh - 24px) * 16 / 9); /* 16:9 aspect ratio for mobile */
  }
}
</style>
